import React, { useContext } from "react";
import "../app.css";
import { Link } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

const Navbar = ({ handleSidebar ,shown}) => {
  const authContext = useContext(AuthContext);

  return (
    <nav
      id="nav"
      style={{
        backgroundColor: "#fff",
        zIndex: "0",
        height: "75px",
        position: "absolute",
        top: "0",
        right: "0",
        width: `${shown?"calc(100vw - 305px)":'80vw'}`,
      }}
      className="navbar py-3 d-flex  border-bottom border-opacity-25 border-secondary border-2  
      justify-content-end  align-items-center navbar-expand-lg 
      navbar-light bg-white"

        >
      <div className="container w-75 d-flex align-items-center justify-content-end">
          <FontAwesomeIcon
            onClick={handleSidebar}
            className="barr px-4 fs-4 "
            icon={faBars}
          />
        <div
          style={{
            // position: "fixed",
            right: "20px",
            top: "20px",
            padding: "",
          }}
        >
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="true"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav  d-flex justify-content-between align-items-center  me-auto mb-2 mb-lg-0">
            <li className="nav-item px-3 ">
              <Link className="nav-link  active " aria-current="page" to="/">
                Home
              </Link>
            </li>
            <li className="nav-item px-3">
              {authContext.auth && authContext.auth.user ? (
                <Link className="nav-link " to="/chatbot">
                  Chatbot
                </Link>
              ) : (
                <Link className="nav-link " to="/welcome">
                  Chatbot
                </Link>
              )}
            </li>
            <li className="nav-item px-3">
              <Link
                className="nav-link "
                style={{ width: "max-content" }}
                to="/articles"
              >
                Psychiatric Illness
              </Link>
            </li>
            <li className="nav-item px-3">
              {authContext.auth && authContext.auth.user ? (
                <Link className="nav-link " to="/test">
                  Test
                </Link>
              ) : (
                <Link className="nav-link " to="/welcom2">
                  Test
                </Link>
              )}
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
